import LogRocket              from 'logrocket'; 
import { attributeFromToken,
         isLoggedIn }         from './authService';
import { AwsConstants }       from './environment';

export default function LogRocketInit() {
  if (isLoggedIn()) {
    LogRocket.init(AwsConstants.LogRocket, 
    {
      network: {
        isEnabled : false,
        requestSanitizer: request => {
          request.headers['authorization'] = null;
          
          // if the url contains 'callback'
          if (request.url.toLowerCase().indexOf('callback') !== -1) {
            // ignore the request response pair
            return null;
          }
          else if (request.url.toLowerCase().indexOf('amazonaws.com') !== -1) {
            return null;
          }
          else {
            return request;
          }
        }
      }
    });
    
    LogRocket.identify(attributeFromToken('urn:oid:1.2.840.113556.1.2.610'), {
      name: attributeFromToken('given_name') + ' ' + attributeFromToken('family_name'),
      email: attributeFromToken('email')
    });
  }
}
